import APIClient from '@/shared/http/clients/api'

const resourceName = 'cartao-credito'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

const CreditCardRepository = {
  Search
}

export default CreditCardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/creditcard.js